<template>
  <div style="height: 40px;">
    <v-text-field
      @input="setModelData"
      :label="label"
      single-line
      outlined
      dense
      :value="model"
      :type="inputType"
      full-width
      style="border-radius: 20px;"
      background-color="#ffffff"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    label: "",
    model: "",
    inputType: "",
    autofocus: Boolean,
  },
  name: "Input-text-field",
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped></style>
